import React, { Component } from 'react';
import { Modal, Input, DatePicker, Select, message, Upload, Button } from 'antd';
import $, { xToken } from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import { tableColumns, tabs } from '../pageMes';
import Text from '../../../basicElement/Text';
import moment from 'moment';
import SearchRetrieve from '../../../common/SearchRetrieve.new';

const DataFormat = 'YYYY-MM-DD';
const MonthFormat = 'YYYY-MM';
const Option = Select.Option;
const { TextArea } = Input;
const { MonthPicker } = DatePicker;

class Update extends Component {

    state = {
        visible: false,
        data:[],
        record:{},
        isEdit:false,
        seveParams:{},
        fileList:[],
        canSearchSite:0,
        expandedRowKeys:null,
    }

    show = ( record, isEdit, expandedRowKeys ) => {
        if(isEdit) this.getParamsData(record)
        this.setState({ visible: true, record, isEdit, expandedRowKeys })
    }

    getParamsData = record => {
        this.setState({
            seveParams:{
                beginYearMonth: record.beginYearMonth ? moment(record.beginYearMonth).format(MonthFormat) : null,
                endYearMonth: record.endYearMonth ? moment(record.endYearMonth).format(MonthFormat) : null,
                date: record.date ? moment(record.date).format(DataFormat) : null,
                roleCode: record.roleCode || null,
                hospitalId: record.hospitalId || null,
                hospitalName: record.hospitalName || null,
                hospitalDepartmentId: record.hospitalDepartmentId || null,
                hospitalDepartmentName: record.departmentName || null,
                remark: record.remark || null,
                complainType: record.complainType || null,
                investigationId: record.investigationId || null,
                investigationName: record.investigationName || null,
                reason: record.reason || null,
                type: record.type || null,
            },
            fileList: record.fileList || [],
        })
    }

    submit = () =>{
        const { seveParams, record, fileList, expandedRowKeys } = this.state;
        const { menuType, search, activeKey } = this.props;
        (fileList || []).forEach((item, index) => {
            seveParams[`ids[${index}]`] = item.response.fileMetaId;
        });
        const options = {
            method: 'POST',
            url: API_URL.user.addCrcPost,
            data: {
                ...seveParams,
                menuType,
                id: record[tableColumns[activeKey].submitId],
                userId: record.userId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success)
                this.handleCancel()
                search(record, expandedRowKeys)
            },
        };
        $.sendRequest(options);
    }

    handleOk = () => {
        const { activeKey } = this.props;
        const { seveParams, fileList, canSearchSite } = this.state;
        try{
            tableColumns[activeKey].createMes.forEach(el => {
                if(el.condition && (seveParams[el.condition] === el.conditionValue) && !seveParams[el.value]){
                    throw new Error(`请输入${el.name}`)
                }else if(el.name == '附件' && fileList.length == 0) {
                    throw new Error(`请选择上传附件`)
                }else if(!seveParams[el.value] && el.name !== '附件' ) {
                    throw new Error(`请输入${el.name}`)
                }
            });
        } catch (e) {
            message.error(e.message)
            return
        }
        if(activeKey == '2'){
            if(seveParams.roleCode == 'PCRC'){
                if(!seveParams.hospitalDepartmentName){
                    message.error(`请输入科室名称`)
                    return
                }
            }
        }
        if(activeKey == '6'){
            if(seveParams.complainType == 'DEPARTMENT_INVESTIGATION' || seveParams.complainType == 'DEPARTMENT'){
                if(!seveParams.hospitalName){
                    message.error(`请输入医院名称`)
                    return
                }
                if(!seveParams.hospitalDepartmentName){
                    message.error(`请输入科室名称`)
                    return
                }
            }
        }
        if(activeKey == '7' && canSearchSite && !seveParams.hospitalDepartmentName){
            message.error(`请输入科室名称`)
            return
        }
        this.submit()
    }

    handleChange = (value , key)=>{
        const {seveParams} = this.state;
        if(key == 'roleCode' || key == 'complainType'){
            seveParams.hospitalId = undefined;
            seveParams.hospitalName = undefined;
            seveParams.hospitalDepartmentId = undefined;
            seveParams.hospitalDepartmentName = undefined;
        }
        seveParams[key] = value;
        this.setState({seveParams})
    }

    handleSearchChange = (option, key) => {
        const { seveParams } = this.state;
        const { value, text, roleCode, canSearchSite } = option;
        const { menuType } = this.props;
        seveParams[`${key}Id`] = value;
        seveParams[`${key}Name`] = text;
        if (key === 'hospital') {
            seveParams.hospitalDepartmentId = undefined;
            seveParams.hospitalDepartmentName = undefined;
        }
        if (key === 'hospitalDepartment' && menuType === 'establishedInvLost') {
            seveParams.roleCode = value ? roleCode : 'PCRC';
        }
        if (key === 'hospital' && menuType === 'establishedInvLost') {
            seveParams.hospitalDepartmentId = undefined;
            seveParams.hospitalDepartmentName = undefined;
            seveParams.roleCode = value ? roleCode : undefined;
            this.setState({ canSearchSite })
        }
        this.setState({ seveParams });
    }
    
    handleCancel = () => {
        this.setState({ 
            visible: false, 
            isEdit:false,
            data:[], 
            record:{}, 
            fileList:[], 
            seveParams:{},
            canSearchSite:0,
            expandedRowKey:null,
        })
    }

    beforeUpload = file => {
        const { fileList = [] } = this.state;
        const isLt30M = file.size / 1024 / 1024 <=30;
        if (fileList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
        if (!isLt30M) {
            message.warning('文件大小不能超过30M');
            return false;
        }
    }

    handleFileChange = ({ file, fileList }) => {
        if (file.status == "done") {
            if (file.response.error) {
                message.error(file.response.error);
                file.status = 'removed';
                const fileData = [...this.state.fileList];
                const index = fileData.indexOf(file);
                fileList.splice(index, 1);
            } else if (file.response.success) {
                message.success('上传附件成功');
            }
        }
        this.setState({ fileList });
    }

    handleFileRemove = (file, message = true) => {
        const options = {
            method: 'POST',
            url: API_URL.user.deleteFileMeta,
            data: {
                fileMetaId: file.response.fileMetaId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.error) {
                    message && message.error(res.error);
                } else {
                    message && message.success(res.success);
                }
            }
        };
        $.sendRequest(options);
    }

    render () {
        const { activeKey, menuType } = this.props;
        const { visible, isEdit, seveParams, record, canSearchSite, fileList = [] } = this.state;
        const {
            roleCode,
            complainType,
        } = seveParams;
        const {
            userCompellation,
            employeeCode,
            userId,
        } = record;
        const uploadParams = {
            menuType: menuType,
            path: Date.now(),
            curUserId: sessionStorage.userId,
            curEmployeeCode: sessionStorage.curEmployeeCode || '',
        }
        id: 
        if(record[tableColumns[activeKey].submitId]) {
            uploadParams.id = record[tableColumns[activeKey].submitId]
        }

        return(
            <Modal
                title={`${isEdit ? '修改' : activeKey !== '2' ? '添加' : '登记'}${tableColumns[activeKey].updeteTitle}`}
                visible={visible}
                width={500}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                >
                    <div className="modal-content" style={{ padding: '0 5px' }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left" style={{ padding: '0' }}><Text asterisk={false} colon={true}>人员</Text></div>
                                <div>{`${userCompellation}[${employeeCode}]`}</div>
                            </li>
                            {
                                (activeKey == '3' || activeKey == '4' || activeKey == '6' || activeKey == '8' ) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={true} colon={true}>时间</Text></div>
                                    <div >
                                        <DatePicker
                                            format={DataFormat}
                                            placeholder="请选择"
                                            style={{ width: 200 }}
                                            value={seveParams.date ? moment(seveParams.date) : ''}
                                            onChange={(date, dateStr) => this.handleChange(dateStr, 'date')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                (activeKey == '2' || activeKey == '5' || activeKey == '7' || activeKey == '9' ) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={true} colon={true}>开始时间</Text></div>
                                    <div >
                                        <MonthPicker
                                            format={MonthFormat}
                                            placeholder="请选择"
                                            style={{ width: 200 }}
                                            value={seveParams.beginYearMonth ? moment(seveParams.beginYearMonth) : ''}
                                            onChange={(date, dateStr) => this.handleChange(dateStr, 'beginYearMonth')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                (activeKey == '2' || activeKey == '5' || activeKey == '7' || activeKey == '9' ) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={true} colon={true}>结束时间</Text></div>
                                    <div >
                                        <MonthPicker
                                            format={MonthFormat}
                                            placeholder="请选择"
                                            style={{ width: 200 }}
                                            value={seveParams.endYearMonth ? moment(seveParams.endYearMonth) : ''}
                                            onChange={(date, dateStr) => this.handleChange(dateStr, 'endYearMonth')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                (activeKey == '2') &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={true} colon={true}>负责角色</Text></div>
                                    <div >
                                        <Select
                                            placeholder="请选择"
                                            style={{ width: 200 }}
                                            value={seveParams.roleCode}
                                            onChange={value => this.handleChange(value, 'roleCode')}
                                        >
                                            <Option key={'site leader'} value={'site leader'}>site leader</Option>
                                            <Option key={'PCRC'} value={'PCRC'}>PCRC</Option>
                                        </Select>
                                    </div>
                                </li>
                            }
                            {
                                (activeKey == '6') &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={true} colon={true}>科室投诉或卡项目</Text></div>
                                    <div >
                                        <Select
                                            placeholder="请选择"
                                            style={{ width: 200 }}
                                            value={seveParams.complainType}
                                            onChange={value => this.handleChange(value, 'complainType')}
                                        >
                                            <Option key={'DEPARTMENT'} value={'DEPARTMENT'}>科室投诉</Option>
                                            <Option key={'INVESTIGATION'} value={'INVESTIGATION'}>卡项目</Option>
                                            <Option key={'DEPARTMENT_INVESTIGATION'} value={'DEPARTMENT_INVESTIGATION'}>科室投诉和卡项目</Option>
                                        </Select>
                                    </div>
                                </li>
                            }
                            {
                                (activeKey == '2' || activeKey == '3' || activeKey == '7' || (activeKey == '6' && (complainType == 'DEPARTMENT' || complainType == 'DEPARTMENT_INVESTIGATION'))) && 
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={true} colon={true}>医院名称</Text></div>
                                    <div >
                                        <SearchRetrieve
                                            keyword='hospitalName'
                                            style={{ width: 200 }}
                                            params={{ limit: 20, userId:menuType === 'establishedInvLost' ? userId : null }}
                                            value={seveParams.hospitalName}
                                            placeholder="输入医院名称检索"
                                            url={menuType !== 'establishedInvLost' ? API_URL.hospital.hospitalList : API_URL.user.queryHospitalByHospitalDeptWorkUserId}
                                            config={{ id: 'hospitalId', name: 'hospitalName', type: menuType === 'establishedInvLost' ? 'userHospital' : undefined }}
                                            onChange={option => this.handleSearchChange(option, 'hospital')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                ((activeKey == '2' &&  roleCode == 'PCRC') || activeKey == '3' || activeKey == '7' || (activeKey == '6' && (complainType == 'DEPARTMENT' || complainType == 'DEPARTMENT_INVESTIGATION'))) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={(activeKey == '2' || (activeKey == '7' && canSearchSite) || (activeKey == '6' && (complainType == 'DEPARTMENT' || complainType == 'DEPARTMENT_INVESTIGATION')))? true: false} colon={true}>科室名称</Text></div>
                                    <div >
                                        <SearchRetrieve
                                            keyword='hospitalDepName'
                                            style={{ width: 200 }}
                                            params={{ limit: 20, hospitalId:seveParams.hospitalId, userId:menuType === 'establishedInvLost' ? userId : null  }}
                                            disabled={!seveParams.hospitalId}
                                            value={seveParams.hospitalDepartmentName}
                                            placeholder="输入科室名称检索"
                                            url={menuType !== 'establishedInvLost' ? API_URL.hospital.queryDepWhenAddDoctor : API_URL.user.queryHospitalDepartmentByHospitalDeptWorkUserId }
                                            config={{ id: 'hospitalDepartmentId', name: menuType !== 'establishedInvLost' ? 'departmentLocalName' : 'departmentName', type: menuType === 'establishedInvLost' ? 'department' : null }}
                                            onChange={option => this.handleSearchChange(option, 'hospitalDepartment')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                (activeKey == '6' && (complainType == 'INVESTIGATION' || complainType == 'DEPARTMENT_INVESTIGATION' )) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={activeKey == '2' ? true: false} colon={true}>涉及项目简称</Text></div>
                                    <div >
                                        <SearchRetrieve
                                            keyword='investigationName'
                                            style={{ width: 160 }}
                                            params={{ limit: 20 , isHistory: 'FALSE' }}
                                            placeholder="输入名称检索"
                                            value={seveParams.investigationName}
                                            url={API_URL.investigation.queryInvestigationByName}
                                            config={{ id: 'investigationId', name: 'investigationName' }}
                                            onChange={option => this.handleSearchChange(option, 'investigation')}
                                        />
                                    </div>
                                </li>
                                
                            }
                            {
                                activeKey == '7' &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={false} colon={true}>负责角色</Text></div>
                                    <div >
                                        <Select
                                            placeholder="请选择"
                                            style={{ width: 200 }}
                                            disabled={ menuType === 'establishedInvLost' }
                                            value={seveParams.roleCode}
                                            onChange={value => this.handleChange(value, 'roleCode')}
                                        >
                                            <Option key={'site leader'} value={'site leader'}>site leader</Option>
                                            <Option key={'PCRC'} value={'PCRC'}>PCRC</Option>
                                        </Select>
                                    </div>
                                </li>
                            }
                            {
                                activeKey == '9' &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={true} colon={true}>具体行为</Text></div>
                                    <div >
                                        <Select
                                            placeholder="请选择"
                                            style={{ width: 200 }}
                                            value={seveParams.type}
                                            onChange={value => this.handleChange(value, 'type')}
                                        >
                                            <Option key={'rejectArrange'} value={'rejectArrange'}>拒接项目或不服从安排</Option>
                                            <Option key={'transferNegativeEnergy'} value={'transferNegativeEnergy'}>团队传递负能量</Option>
                                            <Option key={'inputDataNotTimely'} value={'inputDataNotTimely'}>各类数据录入不及时</Option>
                                        </Select>
                                    </div>
                                </li>
                            }
                            {
                                (activeKey == '5' || activeKey == '6' || activeKey == '7') &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={activeKey == '5'? true : false} colon={true}>说明</Text></div>
                                    <div >
                                        <TextArea
                                            rows={4}
                                            placeholder="请输入"
                                            style={{ width: 200 }}
                                            value={seveParams.remark}
                                            onChange={e => this.handleChange(e.target.value, 'remark')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                activeKey == '8' &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={true} colon={true}>活动主题</Text></div>
                                    <div >
                                        <TextArea
                                            rows={4}
                                            placeholder="请输入"
                                            style={{ width: 200 }}
                                            value={seveParams.remark}
                                            onChange={e => this.handleChange(e.target.value, 'remark')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                activeKey == '8' &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}><Text asterisk={false} colon={true}>未参加原因</Text></div>
                                    <div >
                                        <Input
                                            placeholder="请输入"
                                            style={{ width: 200 }}
                                            value={seveParams.reason}
                                            onChange={e => this.handleChange(e.target.value, 'reason')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                (activeKey == '3' || activeKey == '4' || activeKey == '5') && 
                                <li className="modal-item">
                                    <div className="item-left" style={{ padding: '0' }}>
                                        <Text asterisk={activeKey == '3'? true : false} colon={true}>附件</Text>
                                    </div>
                                    <div style={{ width: '200px' }}>
                                        <Upload
                                            action={API_URL.user.uploadCrcPostFile}
                                            data={uploadParams}
                                            beforeUpload={this.beforeUpload}
                                            onChange={this.handleFileChange}
                                            onRemove={this.handleFileRemove}
                                            fileList={fileList}
                                            headers={xToken}
                                        >
                                            <Button style={{ width: 80 }}>选择文件</Button>
                                        </Upload>
                                    </div>
                                </li>
                            }
                        </ul>
                    </div>
            </Modal>
        )
    }
}

export default Update


// WEBPACK FOOTER //
// ./src/components/user/crcPostRank/components/Update.js